import { Component, OnInit, ViewChild } from '@angular/core';
import { QuillEditorComponent } from 'ngx-quill';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IComplaintCategory, IComplaintCategoryMapping } from 'src/app/interface/dto';
import { ComplaintService } from 'src/app/services/complaint-services.service';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-add-complaint-category-mapping',
  templateUrl: './add-complaint-category-mapping.component.html',
  styleUrls: ['./add-complaint-category-mapping.component.scss']
})
export class AddComplaintCategoryMappingComponent implements OnInit {

   selectedCategoryMap: IComplaintCategoryMapping = {
     categoryID: '',
     examStatus: '',
     id: 0
   };
  text = 'Add';
  @ViewChild('editor') editor: QuillEditorComponent;

  constructor(private popoverRef: PopoverRef<AddComplaintCategoryMappingComponent>,
    private complaintService: ComplaintService, private snackBar: SnackbarService, private evnt: EventService) { }

  ngOnInit() {
    let cat = JSON.parse(sessionStorage.getItem("selectedComplaintCategoryMap")) as IComplaintCategoryMapping
    if (cat) {
      this.selectedCategoryMap = cat;

      this.text = 'Update';
    }
  }

  close() {
    this.popoverRef.close();
    sessionStorage.setItem("selectedComplaintCategoryMap", null);
  }

  async submitCategoryMapping() {
    if (this.selectedCategoryMap.categoryID === '') {
      return this.snackBar.warning("Category field is required");
    }
    if (this.selectedCategoryMap.examStatus === '') {
      return this.snackBar.warning("Examination Status field is required");
    }
    try {
      this.complaintService.saveComplaintCategoryMap(this.selectedCategoryMap).then((response: any) => {
        this.snackBar.success('Category Map saved');
      sessionStorage.setItem("selectedComplaintCategoryMap", null);
        this.evnt.adCategoryMapMessageEvent.emit('refreshCategoryMap');
        this.close();
      });
    } catch (error) {
      this.snackBar.error("Error while saving category");
      console.log('Error:' + error);
    }


  }

}
